import { render, staticRenderFns } from "./RemindPasswordForm.vue?vue&type=template&id=c168b914&scoped=true&"
import script from "./RemindPasswordForm.vue?vue&type=script&lang=ts&"
export * from "./RemindPasswordForm.vue?vue&type=script&lang=ts&"
import style0 from "./RemindPasswordForm.vue?vue&type=style&index=0&id=c168b914&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c168b914",
  null
  
)

export default component.exports